/**
 * Transaction table definition for the Evolu schema.
 *
 * Extracted from schema.ts to keep the main schema file under
 * the 300-line limit. Defines the unified transaction log across
 * all payment methods.
 *
 * @module db/tables/transaction-table
 */

import { NonEmptyString1000, nullOr, String, Number, SqliteBoolean } from '@evolu/common';
import { TransactionId } from '../schema-ids';

/**
 * Unified transaction log across all payment methods.
 *
 * Columns:
 * - Core: type, status, amountSats, feeSats, direction
 * - Lightning: paymentHash, bolt11, bolt12Offer, preimage
 * - Cashu: mintId, cashuToken
 * - Metadata: contactId, contactName, categoryId, note, memo, kind
 * - Tracking: lightningAddress, externalId, walletConnectionId
 * - Timestamps: initiatedAt, settledAt, expiresAt
 * - Export: custodyType, exportedToSatsflow, exportedToClams
 */
export const TransactionTable = {
  id: TransactionId,
  type: NonEmptyString1000,
  status: NonEmptyString1000,
  amountSats: Number,
  feeSats: nullOr(Number),
  direction: NonEmptyString1000,
  paymentHash: nullOr(String),
  bolt11: nullOr(String),
  bolt12Offer: nullOr(String),
  preimage: nullOr(String),
  mintId: nullOr(String),
  cashuToken: nullOr(String),
  contactId: nullOr(String),
  contactName: nullOr(String),
  categoryId: nullOr(String),
  note: nullOr(String),
  memo: nullOr(String),
  kind: nullOr(String),
  lightningAddress: nullOr(String),
  externalId: nullOr(String),
  walletConnectionId: nullOr(String),
  initiatedAt: NonEmptyString1000,
  settledAt: nullOr(String),
  expiresAt: nullOr(String),
  custodyType: NonEmptyString1000,
  exportedToSatsflow: SqliteBoolean,
  exportedToClams: SqliteBoolean,
} as const;
